module.exports = __webpack_public_path__ + "img/005-giraffe.572ff932.svg";